import React from 'react'
import _ from 'lodash';
import { useSelector } from 'react-redux';

import showToastNotification from './../../../widgets/toastify';
import * as Constants from './../../../../helpers/constants';
import { ApiHelper } from '../../../../helpers/apihelper';

const SignUpLink = ({ userData, client }) => {
  const userName = useSelector(state => state.user.name);
  const id = useSelector((state) => state.user.id);

  function onGetSignupLink() {
    const requestBody = {
      co_user_id: userData.user_id,
      user_id: userData.user_id,
      action_type: 'sign_up',
      client_secret: Constants.CLIENT_SECRET,
      crm_user_data: {
        user_id: id,
        name: userName
      },
      crm_user_id: id
    };

    let body = _.pick(requestBody, ApiHelper(client, 'SIGN_UP_LINK').API_BODY)
    ApiHelper(client, 'SIGN_UP_LINK').API(client, body)
      .then((response) => {
        if (response.status === Constants.CO_API.FAILED) {
          showToastNotification({
            message: 'Signup Link copied unsuccessfully',
            isSuccess: false,
          });
        } else if (response.status === Constants.CO_API.SUCCESS) {
          navigator.clipboard.writeText(response.data.reset_url)
          showToastNotification({
            message: 'Signup Link copied successfully',
            isSuccess: true,
          });
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }
  return (
    <p
      onClick={onGetSignupLink}
      className='m-0 text-wrap'
    >
      Get Sign up Activation Link
    </p>
  )
}

export default SignUpLink